
<component
	:is="button"
	class="button-base"
	v-bind="$props"
	@click="handleClick($event)"
	@mousedown="handleMouseDown($event)"
>
	<span class="button-content">
		<slot />
	</span>
	<Icon
		v-if="loading && state === 'icon'"
		name="loading"
		size="medium"
		class="position-absolute"
		state="primary"
		type="outlined"
	/>
	<Icon
		v-if="loading && state !== 'icon' && loadingType === 'icon'"
		name="loading"
		size="18px"
		class="flow-btn-loading-icon"
		state="black"
		type="outlined"
		:effects="false"
	/>
</component>
